import { Card } from '@paysera/ui';
import { DetailRow } from './DetailRow';
export const InvestmentItem = ({ rows, actions }) => (<Card className="flex flex-col gap-4">
        <div className="flex flex-col gap-4">
            {rows.map((row) => {
        const value = typeof row.value === 'object' && row.value !== null && 'text' in row.value ? (<span className={row.value.className}>{row.value.text}</span>) : (row.value);
        return <DetailRow key={row.key} label={row.label} value={value}/>;
    })}
            {actions}
        </div>
    </Card>);
